import React from 'react';
import { FiX, FiSearch, FiPlus } from 'react-icons/fi';

const CustomerSelectionModal = ({
  show,
  customers,
  customerSearch,
  setCustomerSearch,
  showAddCustomerForm,
  setShowAddCustomerForm,
  newCustomerForm,
  setNewCustomerForm,
  onClose,
  onSelectCustomer,
  onAddNewCustomer
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6 max-h-[80vh] overflow-hidden flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Chọn khách hàng</h2>
          <button onClick={onClose}>
            <FiX size={24} />
          </button>
        </div>

        {!showAddCustomerForm ? (
          <>
            {/* Search */}
            <div className="relative mb-4">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Tìm theo tên hoặc SĐT..."
                value={customerSearch}
                onChange={(e) => setCustomerSearch(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-lg"
              />
            </div>

            {/* Customer List */}
            <div className="flex-1 overflow-y-auto space-y-2 mb-4">
              {customers.length === 0 ? (
                <p className="text-gray-500 text-center py-4">
                  {customerSearch ? 'Không tìm thấy khách hàng' : 'Chưa có khách hàng nào'}
                </p>
              ) : (
                customers.map(customer => (
                  <button
                    key={customer._id}
                    onClick={() => onSelectCustomer(customer._id)}
                    className="w-full text-left p-3 border rounded-lg hover:bg-green-50 hover:border-green-500 transition-colors"
                  >
                    <div className="font-semibold">{customer.name}</div>
                    {customer.phone && (
                      <div className="text-sm text-gray-500">{customer.phone}</div>
                    )}
                  </button>
                ))
              )}
            </div>

            {/* Add New Customer Button */}
            <button
              onClick={() => setShowAddCustomerForm(true)}
              className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-green-500 hover:text-green-600 flex items-center justify-center"
            >
              <FiPlus className="mr-2" /> Thêm khách hàng mới
            </button>
          </>
        ) : (
          /* Add New Customer Form */
          <form onSubmit={onAddNewCustomer} className="space-y-4">
            <div>
              <label className="block font-semibold mb-2">Tên khách hàng *</label>
              <input
                type="text"
                value={newCustomerForm.name}
                onChange={(e) => setNewCustomerForm({ ...newCustomerForm, name: e.target.value })}
                className="w-full border rounded-lg px-4 py-2"
                required
              />
            </div>
            <div>
              <label className="block font-semibold mb-2">Số điện thoại</label>
              <input
                type="tel"
                value={newCustomerForm.phone}
                onChange={(e) => setNewCustomerForm({ ...newCustomerForm, phone: e.target.value })}
                className="w-full border rounded-lg px-4 py-2"
              />
            </div>
            <div className="flex space-x-3">
              <button
                type="button"
                onClick={() => setShowAddCustomerForm(false)}
                className="flex-1 py-2 border rounded-lg hover:bg-gray-100"
              >
                Quay lại
              </button>
              <button
                type="submit"
                className="flex-1 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Thêm & Gán
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CustomerSelectionModal;
